import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

class ProfilesIndex extends React.Component {
  render() {
    return (
      <div>
        <h1>Profiles</h1>
        {this.props.data.allProfileJson.edges.map(({ node }) => (
          <div key={node.fields.slug}>
            <Link to={node.fields.slug}>{node.name}</Link>
          </div>
        ))}
      </div>
    )
  }
}

export default ProfilesIndex

export const query = graphql`
  query IndexQuery {
    allProfileJson {
      totalCount
      edges {
        node {
          name
          fields {
            slug
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js